export const MAINTENANCE_MODULE_NAMESPACE = 'maintenance'
export const EQUIPMENT_SET = 'EQUIPMENT_SET'
export const MAINTENANCE_SET_ISLOADING = 'MAINTENANCE_SET_ISLOADING'
export const EQUIPMENT_ACTION = 'EQUIPMENT_ACTION'
export const EQUIPMENT_RESET = 'EQUIPMENT_RESET'
export const EQUIPMENT_EDIT = 'EQUIPMENT_EDIT'
export const MAINTENANCE_SET_BY_FIELD = 'MAINTENANCE_SET_BY_FIELD'
export const MAINTENANCE_TEMPLATE_SET_BY_FIELD = 'MAINTENANCE_TEMPLATE_SET_BY_FIELD'
export const EQUIPMENT_SET_BY_FIELD = 'EQUIPMENT_SET_BY_FIELD'
export const EQUIPMENT_CREATE = 'EQUIPMENT_CREATE'
export const EQUIPMENT_RECORD = 'EQUIPMENT_RECORD'
export const EQUIPMENT_CURRENT_SET = 'EQUIPMENT_CURRENT_SET'
export const EQUIPMENT_GET_EQUIPMENTS = 'EQUIPMENT_GET_EQUIPMENTS'
export const EQUIPMENT_SET_EQUIPMENTS = 'EQUIPMENT_SET_EQUIPMENTS'
export const EQUIPMENT_GET = 'EQUIPMENT_GET'
export const VEHICLE_GET = 'VEHICLE_GET'
export const EQUIPMENT_UPDATE = 'EQUIPMENT_UPDATE'
export const EQUIPMENT_SET_ATTRIBUTE_TO_EDIT = 'EQUIPMENT_SET_ATTRIBUTE_TO_EDIT'
export const EQUIPMENT_SET_CURRENT_ATTRIBUTE = 'EQUIPMENT_SET_CURRENT_ATTRIBUTE'
export const EQUIPMENT_PARAMETER = 'EQUIPMENT_PARAMETER'
export const EQUIPMENT_BLOCK = 'EQUIPMENT_BLOCK'
export const VEHICLE_FLEET_BLOCK = 'VEHICLE_FLEET_BLOCK'
export const VEHICLE_FLEET_PARAMETER = 'VEHICLE_FLEET_PARAMETER'
export const MAINTENANCE_GET_INTERVAL_TYPES = 'MAINTENANCE_GET_INTERVAL_TYPES'
export const MAINTENANCE_SET_INTERVAL_TYPES = 'MAINTENANCE_SET_INTERVAL_TYPES'
export const MAINTENANCE_GET_TEMPLATES = 'MAINTENANCE_GET_TEMPLATES'
export const MAINTENANCE_SET_TEMPLATES = 'MAINTENANCE_SET_TEMPLATES'
export const MAINTENANCE_POST_CREATE = 'MAINTENANCE_POST_CREATE'
export const MAINTENANCE_PATCH_UPDATE = 'MAINTENANCE_PATCH_UPDATE'
export const MAINTENANCE_TEMPLATE_POST_CREATE = 'MAINTENANCE_TEMPLATE_POST_CREATE'
export const MAINTENANCE_TEMPLATE_PATCH_UPDATE = 'MAINTENANCE_TEMPLATE_PATCH_UPDATE'
export const MAINTENANCE_GET_MAINTENANCES = 'MAINTENANCE_GET_MAINTENANCES'
export const MAINTENANCE_SET_MAINTENANCES = 'MAINTENANCE_SET_MAINTENANCES'
export const MAINTENANCE_RESET_MAINTENANCES = 'MAINTENANCE_RESET_MAINTENANCES'
export const MAINTENANCE_SET_SEARCHPARAMS = 'MAINTENANCE_SET_SEARCHPARAMS'
export const MAINTENANCE_INIT_FIELDS = 'MAINTENANCE_INIT_FIELDS'
export const MAINTENANCE_TEMPLATE_INIT_FIELDS = 'MAINTENANCE_TEMPLATE_INIT_FIELDS'



// WEBPACK FOOTER //
// ./src/store/maintenance/maintenance-types.store.ts